import { render, staticRenderFns } from "./PreviousPaymentsTable.vue?vue&type=template&id=ddbf820c&scoped=true"
import script from "./PreviousPaymentsTable.vue?vue&type=script&lang=js"
export * from "./PreviousPaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./PreviousPaymentsTable.vue?vue&type=style&index=0&id=ddbf820c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbf820c",
  null
  
)

export default component.exports